namespace TabAurous.ECommerce {
    export namespace ShippingService {
        export const baseUrl = 'ECommerce/Shipping';

        export declare function Create(request: Serenity.SaveRequest<ShippingRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ShippingRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ShippingRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetCustomerandProductDetails(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ShippingRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<ShippingRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "ECommerce/Shipping/Create",
            Update = "ECommerce/Shipping/Update",
            Delete = "ECommerce/Shipping/Delete",
            Retrieve = "ECommerce/Shipping/Retrieve",
            GetCustomerandProductDetails = "ECommerce/Shipping/GetCustomerandProductDetails",
            List = "ECommerce/Shipping/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'GetCustomerandProductDetails', 
            'List'
        ].forEach(x => {
            (<any>ShippingService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
